import React from "react";
import PharmacyItem from "./PharmacyItem";
import { Button, Heading, Text } from "@reliance/design-system";
import House from "../img/House.png";
import { logAnalyticsEvent } from "../firebaseInit";
import { eventName } from "../services/constants";
import { useTranslation } from "react-i18next";

const ConfirmPharmacySelectionV2 = ({
  pharmacy,
  handleGoback,
  handleProceed,
  contactDetails,
  pickupType,
  ...props
}) => {
  const { t } = useTranslation(["consultations"]);
  const { prescriptionId } = props;

  logAnalyticsEvent(eventName.VIEW_PRESCRIPTION_PICKUP_CONFIRMATION, {
    states: contactDetails?.state,
    item_name: prescriptionId,
    type: pickupType,
  });

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 15,
        }}
      >
        <img src={House} alt=" " width={40} />
      </div>
      <div>
        <Heading level={"h4"} style={{ textAlign: "center", marginBottom: 10 }}>
          {t("confirmPharmacySelectionHeading")}
        </Heading>
      </div>
      <PharmacyItem pharmacy={pharmacy} />
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <Text as="div" variant="lg/normal" style={{ fontSize: 15 }}>
          {" "}
          {t("confirmationQuestion")}
        </Text>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 8,
            padding: 10,
          }}
        >
          <Button
            onClick={() => {
              logAnalyticsEvent(eventName.REJECT_PRESCRIPTION_PICKUP_SLA, {
                states: contactDetails?.state,
                item_name: prescriptionId,
                type: pickupType,
              });
              handleGoback();
            }}
            style={{
              width: "48%",
              fontSize: 15,
              height: 50,
              backgroundColor: "white",
              color: "black",
              borderWidth: "1px",
              borderColor: "#E5E5E7",
            }}
          >
            {t("goBack")}
          </Button>
          <Button
            className="e2e-confirm-pharmacy-selection-button"
            onClick={() => {
              logAnalyticsEvent(eventName.ACCEPT_PRESCRIPTION_PICKUP_SLA, {
                states: contactDetails?.state,
                item_name: prescriptionId,
                type: pickupType,
              });
              handleProceed();
            }}
            style={{ width: "48%", fontSize: 15, height: 50 }}
          >
            {t("proceed")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPharmacySelectionV2;
